import { Avatar, Paper, Stack, Typography, Box } from "@mui/material";
import React , {useEffect} from "react";
import { GetProfileImages } from "../DocumentDetails/slice";
import { DEFAULT_AVATAR_URL } from "../../common/enum";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import StorefrontIcon from "@mui/icons-material/Storefront";
import AvatarGroup from "@mui/material/AvatarGroup";
import { useDispatch, useSelector } from "react-redux";
const NotificationCard = ({ notification, t }) => {
  const updateNotification = React.useCallback(async () => {
    try {
      await updateDoc(doc(db, "notifications",notification.notificationUid), {
        ...notification,
        isRead: true,
      });
    } catch (err) {
      //console.log(err);
    }
  }, []);

  React.useEffect(() => {
    if (!notification.isRead) {
      updateNotification();
    }
  }, [notification]);


const dispatch = useDispatch();
  const [profilepictureuri, setprofilepictureuri] = React.useState("");

  useEffect(() => {
    if(notification.collectorDetail.entity){
        if(notification?.collectorDetail.entity.profilePicture != "string" && notification?.collectorDetail.entity.profilePicture != null ){
              dispatch(GetProfileImages(notification?.collectorDetail.entity.profilePicture))
              .unwrap()
                .then((response) => {
                  if(response.isActive != null){
                    setprofilepictureuri(response.isActive);
                  }else{
                    setprofilepictureuri(DEFAULT_AVATAR_URL);
                  }
                })
            }
    }else{
      if( notification.collectorDetail.profilePicture != "string" &&  notification.collectorDetail.profilePicture != null ){
              dispatch(GetProfileImages(notification.collectorDetail.profilePicture))
              .unwrap()
                .then((response) => {
                  if(response.isActive != null){
                    setprofilepictureuri(response.isActive);
                  }else{
                    setprofilepictureuri(DEFAULT_AVATAR_URL);
                  }
                })
            }
    }
    
	})

  
  return (
    <Paper
    variant="outlined"
    sx={{
      p: 1,
      m: 1,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    }}
   
  >
    <Stack direction={"column"}>
        <Stack direction="column" spacing={1}>
        <Stack direction="row" sx={{alignItems: "center"}}>
            <Avatar
              alt={notification.collectorDetail.entity ? notification.collectorDetail.entity.entityName : notification.collectorDetail.entityName}
              src={
                notification.collectorDetail.entity ?
                notification.collectorDetail.entity.profilePicture === "string" ||
                notification.collectorDetail.entity.profilePicture === null
                  ? DEFAULT_AVATAR_URL
                  : profilepictureuri

                  :
                  notification.collectorDetail.profilePicture === "string" ||
                  notification.collectorDetail.profilePicture === null
                  ? DEFAULT_AVATAR_URL
                  : profilepictureuri
              }
              sx={{
                backgroundColor: "green",
                width: "24px",
                height: "24px"
              }}
          />
          <Typography variant="body1" fontFamily={"Poppins"} mx={1}>
            {new Date(
            notification?.donation?.donations?.donation.createdDate
            ).getFullYear()}
           <span title={`Código de doação`} >{notification?.donation?.donations?.donation.id}{" "}</span> (
            {new Date(
              notification.collection.collection.createdDate
            ).getFullYear()}
            <span  title={`Código de reserva`} >{notification.collection.collection.id}</span>)
          </Typography>
        </Stack>
        <Stack direction="row">
          <CalendarMonthOutlinedIcon />
          
          <Typography variant="body2" mx={1}>{<span>{`${notification.updatedDate
            .toDate()
            .toLocaleString("pt", {
              day:"numeric",
              date: "numeric",
              month: "numeric",
              year: "numeric",
              hour: "numeric",
              minute: "numeric",
            })}`}</span>}</Typography>
        </Stack>
        <Stack direction="row">
          <StorefrontIcon />
          
            <Typography variant="body2" fontWeight={600} mx={1}>
          {notification.collectorDetail.entity ? notification.collectorDetail.entity.entityName : notification.collectorDetail.entityName}
          </Typography>
        </Stack>
        <Stack direction="row">
          <Typography
         variant="body2" fontWeight={600} 
          >
          {"Motivo do cancelamento:"}
          </Typography>
        </Stack>
        <Stack direction="row" >
          <Typography variant="body2" fontFamily={"Poppins"} sx={{ mb: 1 }}>
            {notification.cancelMotive}
          </Typography>
          </Stack>
      </Stack>
    </Stack>
</Paper>

    // &&

    // <Paper
    //   variant="outlined"
    //   sx={{ p: 1, m: 1, display: "flex", flexDirection: "column" }}
    // >
    //   <Stack
    //     direction={"row"}
    //     spacing={1}
    //     alignItems={"center"}
    //     justifyContent={"space-between"}
    //   >
    //     <Box sx={{ display: "flex", alignItems: "center" }}>
    //       <Avatar
    //         alt={notification.collectorDetail.entity.entityName}
    //         src={
    //           notification.collectorDetail.entity.profilePicture === "string" ||
    //           notification.collectorDetail.entity.profilePicture === null
    //             ? DEFAULT_AVATAR_URL
    //             : notification.profilePicture
    //         }
    //         sx={{
    //           backgroundColor: "green",
    //         }}
    //       />
    //       <Typography variant="body2" fontWeight={600} mx={1}>
    //         {notification.collectorDetail.entity.entityName}
    //       </Typography>
    //     </Box>
    //     <Typography variant="body1" fontFamily={"Poppins"} sx={{ mb: 1 }}>
    //       {new Date(
    //         notification?.donation?.donations?.donation.createdDate
    //       ).getFullYear()}
    //       {notification?.donation?.donations?.donation.id}{" "}(
    //       {new Date(
    //         notification.collection.collection.createdDate
    //       ).getFullYear()}
    //       {notification.collection.collection.id})
    //     </Typography>
    //     <Typography variant="body2">{`${notification.updatedDate
    //       .toDate()
    //       .toLocaleString("pt", {
    //         day:"numeric",
    //         date: "numeric",
    //         month: "numeric",
    //         year: "numeric",
    //         hour: "numeric",
    //         minute: "numeric",
    //       })}`}</Typography>
    //   </Stack>
    //   <Stack
    //     direction={"row"}
    //     alignItems={"cente"}
    //     justifyContent={"space-between"}
    //   >
    //     <Typography
    //       variant="body1"
    //       fontFamily={"Poppins"}
    //       fontWeight={600}
    //       sx={{ mb: 1 }}
    //     >
    //       {t("cancelMotive")}
    //     </Typography>
    //     <Typography variant="body1" fontFamily={"Poppins"} sx={{ mb: 1 }}>
    //       {notification.cancelMotive}
    //     </Typography>
    //   </Stack>
    // </Paper>
  );
};

export default NotificationCard;
